import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { comfortTrueAsync ,resetState as resetTrueState } from '../features/comfort/comfortTrue/comfortTrueSlice';
import { comfortDareAsync, resetState as resetDareState, selectComfortDare } from '../features/comfort/comfortDare/comfortDareSlice';
import { comfortLightDareAsync, resetState as resetLightDareState } from '../features/comfort/comfortLightDare/comfortLightDareSlice';
import TruthOrDareCard from '../components/TruthOrDareCard';
import QuestionCard from '../components/QuestionCard';
import {
  incrementPlayerOneComfortDaresAnswered, incrementPlayerOneComfortLightDaresAnswered, incrementPlayerOneComfortShotsTaken, incrementPlayerOneComfortTruthsAnswered,
  incrementPlayerTwoComfortDaresAnswered, incrementPlayerTwoComfortLightDaresAnswered, incrementPlayerTwoComfortShotsTaken, incrementPlayerTwoComfortTruthsAnswered, resetGame as resetContestantSlice, toggleComfortPlayerTurn
} from '../features/contestants/contestantsSlice';
import { useNavigate } from 'react-router-dom';
import MenuButton from '../components/MenuButton';
import { setGameReset } from '../features/gamesStatus/gameStatusSlice';
import PopoverCard from '../components/PopoverCard';
import { submitCardInteractionAsync } from '../features/cardInteraction/cardInteractionSlice';
import { recordShots } from '../features/gamesStatus/gameSessionApi';

const ComfortableGame = () => {
  const playerOne = useSelector((state) => state.contestants.playerOne);
  const playerTwo = useSelector((state) => state.contestants.playerTwo);
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const currentPlayer = useSelector((state) => state.contestants.comfortPlayerTurn === "playerOne" ? state.contestants.playerOne : state.contestants.playerTwo)
  const currentPlayerTruthsAnswered = useSelector((state) => state.contestants.comfortPlayerTurn === "playerOne" ? state.contestants.playerOne.comfortTruthsAnswered : state.contestants.playerTwo.comfortTruthsAnswered)
  const currentPlayerLightDaresAnswered = useSelector((state) => state.contestants.comfortPlayerTurn === "playerOne" ? state.contestants.playerOne.comfortLightDaresAnswered : state.contestants.playerTwo.comfortLightDaresAnswered)
  const currentPlayerDaresAnswered = useSelector((state) => state.contestants.comfortPlayerTurn === "playerOne" ? state.contestants.playerOne.comfortDaresAnswered : state.contestants.playerTwo.comfortDaresAnswered)
  const currentPlayerShotsTaken = useSelector((state) => state.contestants.comfortPlayerTurn === "playerOne" ? state.contestants.playerOne.comfortShotsTaken : state.contestants.playerTwo.comfortShotsTaken)
  const sessionId = useSelector((state) => state.gameStatus?.sessions?.comfort?.sessionId);
  const comfortTrue = useSelector((state) => state.comfortTrue)
  const comfortLightDare = useSelector((state) => state.comfortLightDare)
  const comfortDare = useSelector((state) => state.comfortDare)
  const [cardSwitch, setCardSwitch] = useState(true)
  const [truthOrDare, setTruthOrDare] = useState("")
  const [question, setQuestion] = useState("")
  const [questionTimer, setQuestionTimer] = useState("")
  const [drinkQuestion, setDrinkQuestion] = useState("")
  const [attributes, setAttributes] = useState([])
  const [errorPopoverOpen, setErrorPopoverOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [buttonOneText, setButtonOneText] = useState('');
  const [onButtonOne, setOnButtonOne] = useState('');
  const [showButtonOne, setShowButtonOne] = useState(false);
  const gameType = 'comfort'

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    setQuestion(comfortTrue.NewQuestion)
    setQuestionTimer(comfortTrue.NewQuestionTimer)
    setDrinkQuestion(comfortTrue.DrinkQuestion)
    setAttributes(comfortDare.Attributes)
  }, [comfortTrue.NewQuestion])
  
  useEffect(() => {
    setQuestion(comfortLightDare.NewQuestion)
    setQuestionTimer(comfortLightDare.NewQuestionTimer)
    setDrinkQuestion(comfortLightDare.DrinkQuestion)
    setAttributes(comfortDare.Attributes)
  }, [comfortLightDare.NewQuestion])
  
  useEffect(() => {
    setQuestion(comfortDare.NewQuestion)
    setQuestionTimer(comfortDare.NewQuestionTimer)
    setDrinkQuestion(comfortDare.DrinkQuestion)
    setAttributes(comfortDare.Attributes)
  }, [comfortDare.NewQuestion])

  const handleError = (error) => {
    if (error) {
        if (error.status === 403) {
            setErrorMessage('To use this feature, you need to purchase premium.');
            setButtonOneText('Go to Payment Page');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/paymentpage"))
        } else if (error.status === 401) {
            setErrorMessage('You are not logged in.');
            setButtonOneText('Log In');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/login"))
        } else if (error.status === 404) {
            setErrorMessage('For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!');
            setButtonOneText('Try again');
            setQuestion("For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!")
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> setErrorPopoverOpen(false))
        } else {
            setErrorMessage('An unexpected error occurred.');
        }
    } else {
        setErrorMessage('An unexpected error occurred.');
    }
    setErrorPopoverOpen(true);
};

const handleClosePopover = () => {
  setErrorPopoverOpen(false);
};

  const ComfortTrue = async () => {
    try {
      await dispatch(comfortTrueAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Truth')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in ComfortTrue:', error);
      handleError(error); // ✅ Correctly handles popover
    }
    // setQuestion((state) => state.comfortTrue.NewQuestion)

  }

  const ComfortLightDare = async () => {
    try {
      await dispatch(comfortLightDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Light Dare')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in ComfortLightDare:', error);
      handleError(error); // ✅ Correctly handles popover
    } 
    // setQuestion((state) => state.comfortLightDare.NewQuestion)
  }

  const ComfortDare = async () => {
    try {
      await dispatch(comfortDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap(); // ✅ `.unwrap()` ensures rejections are thrown
      setTruthOrDare('Dare');
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in ComfortDare:', error);
      handleError(error); // ✅ Correctly handles popover
    }
    // setQuestion((state) => state.comfortDare.NewQuestion)
  }

  const toggleParticipantsSwitch = () => {
    dispatch(toggleComfortPlayerTurn())
  };
  const addshots = () => {
    if (currentPlayer == playerOne) {
      dispatch(incrementPlayerOneComfortShotsTaken())
    } else { dispatch(incrementPlayerTwoComfortShotsTaken()) }
  }

  const bothDrink = () => {
    dispatch(incrementPlayerOneComfortShotsTaken())
    dispatch(incrementPlayerTwoComfortShotsTaken())
    toggleParticipantsSwitch()
    if (sessionId) recordShots({ sessionId, playerOneShot: true, playerTwoShot: true });
  }

  const addAsnweredQuestionCount = () => {
    if (currentPlayer == playerOne) {
      if (truthOrDare === "Light Dare") {
        dispatch(incrementPlayerOneComfortLightDaresAnswered())
      } else if (truthOrDare === "Truth") {
        dispatch(incrementPlayerOneComfortTruthsAnswered())
      } else {
        dispatch(incrementPlayerOneComfortDaresAnswered())
      }
    } else {
      if (truthOrDare === "Light Dare") {
        dispatch(incrementPlayerTwoComfortLightDaresAnswered())
      } else if (truthOrDare === "Truth") {
        dispatch(incrementPlayerTwoComfortTruthsAnswered())
      } else {
        dispatch(incrementPlayerTwoComfortDaresAnswered())
      }
    }
  }

  const swapTurns = () => {
    addAsnweredQuestionCount()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'comfort',           // could be 'explore', 'open', etc.
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: false
      }));
    setQuestion("")
  }
  const swapTurnsAndAddShot = () => {
    addshots()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'comfort',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: currentPlayer.id,
      shot_player: currentPlayer.id,
      }));
    setQuestion("")
  }
  const swapSkippedTurns = (stoppedById = currentPlayer.id) => {
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'comfort',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: stoppedById,
      }));
    setQuestion("")
  }
  const setPlayerAddShotAndSwap = (participant) => {
    const cardWasSkipped = participant === currentPlayer

    dispatch(submitCardInteractionAsync({
      gameType: 'comfort',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: cardWasSkipped,
      stopped_by: cardWasSkipped ? participant.id : null,
      shot_player: participant.id,
    }))

    addAsnweredQuestionCount()

    if (participant === playerTwo) {
      dispatch(incrementPlayerTwoComfortShotsTaken())
    } else {
      dispatch(incrementPlayerOneComfortShotsTaken())
    }

    toggleParticipantsSwitch()
    toggleCardswitch()
    setQuestion("")
  }

  const toggleCardswitch = () => {
    setCardSwitch(!cardSwitch);
  };
  const restartGame = () =>{
    dispatch(resetContestantSlice(gameType))
    dispatch(resetDareState())
    dispatch(resetLightDareState())
    dispatch(resetTrueState())
    setCardSwitch(true)
  }
  const onQuitWithoutSave = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/chooselevel")
  }
  const onSaveAndQuit = () => {
    navigate("/chooselevel")
  }
  const onSaveAndDownload = () => {
    navigate("/download")
  }
  const onDiscardAndDownload = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/download")
  }
  return (
    <div>
      <MenuButton
        showRestart={true}
        showChangeAccessories={true}
        showQuitGame={true}
        showSwitchGameMode={true}
        showDownload={true}
        onRestartClick={restartGame}
        onQuitGameClick={onQuitWithoutSave}
        onSaveAndQuit={onSaveAndQuit}
        onSaveAndDownload={onSaveAndDownload}
        onDiscardAndDownload={onDiscardAndDownload}
        gameType={gameType}
      />
      <PopoverCard
      mainText={errorMessage}
      open={errorPopoverOpen}
      onClose={()=>navigate('/')}
      showButtonOne={showButtonOne}
      textButtonOne={buttonOneText}
      onButtonOne={onButtonOne}
      />
      {cardSwitch ? <TruthOrDareCard
        fetchDare={ComfortDare}
        fetchLightDare={ComfortLightDare}
        fetchTruth={ComfortTrue}
        playerOne={playerOne}
        playerTwo={playerTwo}
        currentPlayer={currentPlayer}
        currentPlayerTruthsAnswered={currentPlayerTruthsAnswered}
        currentPlayerLightDaresAnswered={currentPlayerLightDaresAnswered}
        currentPlayerDaresAnswered={currentPlayerDaresAnswered}
        currentPlayerShotsTaken={currentPlayerShotsTaken}
        gameType={"comfortable"}
        bothDrink={bothDrink}
        lastTrue={comfortTrue.LastCard}
        lastLight={comfortLightDare.LastCard}
        lastDare={comfortDare.LastCard}
      />
        :
        <QuestionCard
          question={question}
          questionTimer={questionTimer}
          drinkQuestion={drinkQuestion}
          attributes={attributes}
          swapTurns={swapTurns}
          swapTurnsAndAddShot={swapTurnsAndAddShot}
          swapSkippedTurns={swapSkippedTurns}
          truthOrDare={truthOrDare}
          currentPlayer={currentPlayer}
          playerOne={playerOne}
          playerTwo={playerTwo}
          setPlayerAddShotAndSwap={setPlayerAddShotAndSwap}
        />}
    </div>
  )
}

export default ComfortableGame



// <Container>
//   <Header>SARA, it's your turn!</Header>
//   {/* <Header>{comfortDareState.UsedDareQuestionsId}</Header> */}
//   <Box display="flex" justifyContent="center" alignItems="center" flexWrap="wrap">
//     <CustomButton style={{ backgroundColor: '#F48FB1' }} onClick={() => dispatch(comfortTrueAsync({gender:'female',usedid: UsedTrueQuestionsId}))}>Truth</CustomButton>
//     <CustomButton style={{ backgroundColor: '#F06292' }} onClick={() => dispatch(comfortLightDareAsync({gender:'female',usedid: UsedLightDareQuestionsId}))}>Light Dare</CustomButton>
//     <CustomButton onClick={() => dispatch(comfortDareAsync({gender:'female',usedid: UsedDareQuestionsId}))} >Dare</CustomButton>
//     <CustomButton style={{ width: '80%' }}>Both Drink</CustomButton>
//   </Box>
// </Container>